import { OrderResponseDto } from '@planning/app/api'
import { carrierVisitService } from '@planning/services'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetOrdersByVisitIdQuery implements IQueryMessage {
  static type = 'GetOrdersByVisitIdQuery'
  type = GetOrdersByVisitIdQuery.type

  constructor(public visitIds: number[]) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

export const getOrdersByVisitIdQueryHandler: IQueryHandler<
  GetOrdersByVisitIdQuery,
  IEvent<OrderResponseDto[]>
> = async query => {
  const data = await carrierVisitService.ordersByCarrierVisitIds(query.visitIds)

  return new Event(GetOrdersByVisitIdQuery.type, data)
}
